module.exports = __webpack_public_path__ + "img/graph_controller.e82aa4cb.png";